module.exports = __webpack_public_path__ + "static/img/point.1144173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s30/pop/point.png
// module id = JHfn
// module chunks = 2